// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oW47","footer__content":"footer_footer__content__7rl_u"};